(function () {
  // ponytail: deck behaviour only. Anchors still work with JS off; this keeps
  // the page from jumping vertically when a link targets a card in a track,
  // keeps the tab pills in step with the card you are looking at, and gives
  // mouse users prev/next arrows (touch users swipe).
  var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function setActive(deck, id) {
    var tabsEl = deck.querySelector('.hcs-guide__tabs');
    deck.querySelectorAll('.hcs-guide__tabs a').forEach(function (t) {
      var on = t.getAttribute('href') === '#' + id;
      if (on === t.classList.contains('is-active')) return;
      t.classList.toggle('is-active', on);
      if (on) {
        t.setAttribute('aria-current', 'true');
        tabsEl.scrollTo({ left: t.offsetLeft - (tabsEl.clientWidth - t.offsetWidth) / 2, behavior: smooth });
      } else t.removeAttribute('aria-current');
    });
  }

  // Capture phase so this runs before the theme's sitewide smooth-scroll (global.js),
  // which skips links whose default is already prevented. A page scroll that starts
  // after a track scroll cancels the track scroll, so the two must not race.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.hcs-guide a[href^="#"]');
    if (!a) return;
    var card = document.getElementById(a.getAttribute('href').slice(1));
    var deck = card && card.closest('.hcs-guide__deck');
    if (!deck) return;
    e.preventDefault();
    // Tabs never move the page. Other links bring the deck up when it is off screen or low.
    var movePage = false;
    if (!a.closest('.hcs-guide__tabs')) {
      var top = deck.getBoundingClientRect().top;
      movePage = top < 0 || top > window.innerHeight * 0.5;
    }
    var track = card.parentElement;
    // When the page also moves, the track jumps first (instantly) and the page scrolls after it.
    track.scrollTo({ left: card.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: movePage ? 'auto' : smooth });
    if (movePage) deck.scrollIntoView({ behavior: smooth, block: 'start' });
    deck.hcsHold = Date.now() + 900; // the last cards cannot reach the left edge; keep the tapped tab lit
    setActive(deck, card.id);
    history.replaceState(null, '', location.pathname + location.search + a.getAttribute('href'));
  }, true);

  // Prev/next arrows for every horizontal row. Shown only for a fine pointer (CSS).
  var chevron = function (d) {
    return '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="' +
      (d < 0 ? 'M12.5 4.5 7 10l5.5 5.5' : 'M7.5 4.5 13 10l-5.5 5.5') +
      '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };
  document.querySelectorAll('.hcs-guide .hcs-guide__track, .hcs-guide .hcs-guide__fixes').forEach(function (row, i) {
    if (!row.id) row.id = 'hcs-row-' + i;
    var rail = document.createElement('div');
    rail.className = 'hcs-guide__rail';
    row.parentNode.insertBefore(rail, row);
    rail.appendChild(row);
    var btns = [-1, 1].map(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hcs-guide__arrow hcs-guide__arrow--' + (d < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', d < 0 ? 'Previous' : 'Next');
      b.setAttribute('aria-controls', row.id);
      b.innerHTML = chevron(d);
      b.addEventListener('click', function () {
        var first = row.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
        row.scrollBy({ left: d * step, behavior: smooth });
      });
      rail.appendChild(b);
      return b;
    });
    var queued = false;
    function sync() {
      queued = false;
      var max = row.scrollWidth - row.clientWidth;
      btns[0].disabled = row.scrollLeft <= 2;
      btns[1].disabled = row.scrollLeft >= max - 2;
      rail.classList.toggle('is-scrollable', max > 2);
      // Center the arrows on the first photo, whatever the card layout.
      var img = row.querySelector('img');
      if (img && img.offsetHeight) rail.style.setProperty('--hcs-arrow-top', Math.round(img.offsetTop + img.offsetHeight / 2) + 'px');
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
    row.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('load', queue);
    sync();
  });

  if (!('IntersectionObserver' in window)) return;
  document.querySelectorAll('.hcs-guide__deck').forEach(function (deck) {
    var cards = deck.querySelectorAll('.hcs-guide__track > article');
    var full = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { full[en.target.id] = en.intersectionRatio >= 0.95; });
      if (deck.hcsHold && Date.now() < deck.hcsHold) return;
      // after a swipe: the leftmost fully visible card owns the tab
      var first = Array.prototype.find.call(cards, function (c) { return full[c.id]; });
      if (first) setActive(deck, first.id);
    }, { root: deck.querySelector('.hcs-guide__track'), threshold: [0, 0.95] });
    cards.forEach(function (c) { io.observe(c); });
  });
})();
